import { render } from "./RecipeBuilder.vue?vue&type=template&id=167f63e3"
import script from "./RecipeBuilder.vue?vue&type=script&lang=js"
export * from "./RecipeBuilder.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\frval\\real-gestion\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__